import { buildApiCacheKey } from './keys'
import type { BrowserLocalCacheNamespace, BrowserLocalCacheStoreName } from './types'

export type BrowserLocalApiCacheIdentity = {
  namespace: BrowserLocalCacheNamespace
  method?: string
  url: string
  vary?: Array<string | number | boolean | null | undefined>
}

export const API_CACHE_STORE: BrowserLocalCacheStoreName = 'cache_entries'

export const buildBrowserLocalApiCacheKey = (identity: BrowserLocalApiCacheIdentity): string =>
  buildApiCacheKey(identity.namespace, identity.method || 'GET', identity.url, identity.vary || [])

export const shouldUseBrowserLocalApiCache = (method?: string): boolean =>
  String(method || 'GET').trim().toUpperCase() === 'GET'

export const shouldBypassBrowserLocalApiCache = (url: string): boolean => {
  try {
    const parsed = new URL(url, typeof window !== 'undefined' ? window.location.origin : 'http://localhost')
    return parsed.searchParams.get('refresh') === 'true' || parsed.searchParams.get('force_refresh') === 'true'
  } catch {
    return url.includes('refresh=true') || url.includes('force_refresh=true')
  }
}

